const selectors = {
  profile: (state) => state.general.profile,
  studio: (state) => state.general.studio,
  isSidebarOpen: (state) => state.general.isSidebarOpen,

  recipientsList: (state) => state.general.recipientsList,
  search: (state) => state.general.search,
  teachers: (state) => state.general.teachers,
  teachersByRoutine: (state) => state.general.teachersByRoutine,
  students: (state) => state.general.students,
  users: (state) => state.general.users,
  states: (state) => state.general.states,
  cities: (state) => state.general.cities,
  timezones: (state) => state.general.timezones,
  countries: (state) => state.general.countries,
  rooms: (state) => state.general.rooms,
  styles: (state) => state.general.styles,
  tags: (state) => state.general.tags,
  nicknames: (state) => state.general.nicknames,
  routineConsts: (state) => state.general.routineConsts,
  fetchingCitiesStatus: (state) => state.general.fetchingCitiesStatus,
  fetchingStatesStatus: (state) => state.general.fetchingStatesStatus,
  fetchingSearchStatus: (state) => state.general.fetchingSearchStatus,
  fetchingTagsSearchStatus: (state) => state.general.fetchingTagsSearchStatus,
};

export { selectors };
